/** Routes where the global Prism dock widget must not appear. */
export function isPrismDockHiddenPath(pathname: string): boolean {
    if (!pathname || pathname === "/") return true;
    if (pathname === "/auth" || pathname.startsWith("/auth/")) return true;
    if (pathname.startsWith("/modules/prism")) return true;
    if (pathname.startsWith("/modules/ceo-cockpit")) return true;
    return false;
}
